import ConfigurationStrings from "./ConfigurationStrings"

class Strings {
  public static Configuration = new ConfigurationStrings()
}

export default Strings
